import classes from './index.module.css'
import Modal from '@common/Modal'
import s from '../index.module.css';
import { useEffect, useState } from 'react';
import { actionUpdProfile, selectProfile } from '@store/profile.reducer';
import { useDispatch, useSelector } from 'react-redux';
import { InputWhite } from '@UI/New/InputWhite';
import { sortingArray } from '@/helpers/sortingArray';
import { jsonConvert } from '@/helpers/jsonConvert';
import { Radio } from 'antd';
import classNames from 'classnames';
import Button from '@UI/New/Button';
import { smsIntegrationApi } from '@/api';
import { useAddAlert } from '@/hooks/useAddAlert';
import jwt_decode from "jwt-decode";

const RequiredNumberConfirmation = () => {
  const addAlert = useAddAlert();
  const dispatch = useDispatch();
  const profile = useSelector(selectProfile);
  const settings = useSelector(store => store.settings);
  const status = useSelector(store => store.settings?.status);
  const loadingSettings = status < 2;
  const isPhoneConfirmed = !!profile.is_phone_confirmed;
  const thereIsNumber = typeof profile.phone === 'string' && profile.phone.length > 2;
  const confirmationByPhoneNumber = settings?.confirmationByPhoneNumber == 1;
  const confirmationByTelegram = settings?.confirmationByTelegram == 1;
  const isSmsIntegration = (settings?.sms_integration_enabled == 1 && (confirmationByPhoneNumber || confirmationByTelegram));
  const [token, setToken] = useState('');
  const [phone, setPhone] = useState(profile.phone);
  const [code, seCode] = useState('');
  const [disabled, setDisabled] = useState(false);
  
  useEffect(()=>{
    setPhone(profile.phone);
  }, [profile.phone])

  const ordersForConfirmation = !!settings?.ordersForConfirmation?.length ? jsonConvert(settings?.ordersForConfirmation) : [];
  const [confirmationCheckboxes, setConfirmationCheckboxes] = useState([]);
  const [codeDeliveryMethod, setCodeDeliveryMethod] = useState('') // 'sms' или 'telegram'
  useEffect(()=>{
    if(loadingSettings) return;
    const newData = sortingArray([
      ...(confirmationByPhoneNumber ? [{key:'sms', label:'Смс', order: ordersForConfirmation?.findIndex(el=>el=='confirmationByPhoneNumber')}] : []),
      ...(confirmationByTelegram ? [{key: 'telegram', label: 'Telegram', order: ordersForConfirmation?.findIndex(el=>el=='confirmationByTelegram')}] : []),
    ], 'order');

    if(!newData?.length) return;

    setCodeDeliveryMethod(newData?.[0]?.key)
    setConfirmationCheckboxes(newData)
  }, [loadingSettings, settings])

  const requiredNumberConfirmation = settings?.requiredNumberConfirmation == '1';

  const getCode = () => {
    setDisabled(true);
    smsIntegrationApi.getTokenRequiredNumberСonfirmation({
      phone: phone,
      type: [codeDeliveryMethod],
      user_id: profile.id
    })
    .then(({data}) => {
      if(data.status === 'success'){
        setToken(data.token)
        addAlert({title: 'Код отправлен', text: 'Заполните поле с кодом подтверждения'})
      }
    })
    .finally(()=>{
      setDisabled(false)
    })
  }

  const confirmNumber = () => {
    setDisabled(true);
    smsIntegrationApi.confirmationCode({token, code, user_id: profile.id})
    .then((res)=>{
      const newPhone = jwt_decode(token)?.phone;
      if(res.data.status === "success"){
        addAlert({title: 'Успешно', text: 'Код успешно подтвержден'})
        dispatch(
          actionUpdProfile({
            ...profile,
            is_phone_confirmed: 1,
            ...(newPhone && {phone: newPhone})
          }),
        )
      }
    })
    .finally(()=>{
      setDisabled(false)
    })
  }

  if(loadingSettings) return <></>;
  if(!requiredNumberConfirmation) return <></>;
  if(isPhoneConfirmed) return <></>;
  if(!isSmsIntegration) return <></>;

  return (
    <Modal
      active={true}
      setActive={() => {}}
      className={classNames(classes.modalWrapper, s.modalWrapper)}
    >
      <div className={s.modalContainer}>
          <div className={s.modalHeader}>
            <div className={s.modalTitleContainer}>
              <span className={s.modalHeaderTitle}>
                {
                  thereIsNumber ? 'Необходимо подтвердить номер телефона' : 'Необходимо заполнить номер телефона'
                }
              </span>
            </div>
          </div>
          <div className={s.contentWrapper}>
            <InputWhite 
              value={phone} 
              onChange={value => setPhone(value)}
              className={classes.input} 
              placeholder='Номер телефона'
            />
            {
              !!token && <InputWhite 
                value={code} 
                onChange={value => seCode(value)}
                className={classes.inputCode} 
                placeholder='Введите код' />
            }
            {
              !token && confirmationCheckboxes?.length > 1 && <span style={{marginBottom: '10px'}}>
                  Выберите, куда отправить вам временный код для подтверждения
              </span>
            }
            {
              !token && confirmationCheckboxes?.length > 1 && (
                <Radio.Group 
                    value={codeDeliveryMethod}
                    onChange={(e) => setCodeDeliveryMethod(e.target.value)}
                  >
                    {
                      confirmationCheckboxes.map((el)=>{
                        return(
                          <Radio value={el.key}>{el.label}</Radio>
                        )
                      })
                  }
                </Radio.Group>
              )
            }
            {
              !token && (
                <span className={classes.text}>
                  {`Временный код будет отправлен 
                  ${((confirmationCheckboxes?.length == 1) && (confirmationByPhoneNumber)) ? 'по смс' : ''}
                  ${((confirmationCheckboxes?.length == 1) && (confirmationByTelegram)) ? 'в телеграм' : ''}
                  после отправки формы`}
                </span>
              )
            }
            {
              !token && (
                <Button 
                  disabled={disabled}
                  onClick={getCode}
                  leftContent={'Получить код'} />
              )
            }
            {
              token && (
                <Button 
                  disabled={disabled}
                  onClick={confirmNumber}
                  leftContent='Подтвердить' />
              )
            }
          </div>
      </div>
    </Modal>
  )
}


export default RequiredNumberConfirmation
